export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: any; output: any; }
  /** The `Decimal` scalar type represents a decimal floating-point number. */
  Decimal: { input: any; output: any; }
  /** The `LocalDate` scalar type represents a ISO date string, represented as UTF-8 character sequences YYYY-MM-DD. The scalar follows the specification defined in RFC3339 */
  LocalDate: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export type BaleDetail = {
  __typename?: 'BaleDetail';
  baleNumber: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  lineNumber?: Maybe<Scalars['String']['output']>;
  lotNumber?: Maybe<Scalars['String']['output']>;
  netKGs?: Maybe<Scalars['Decimal']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  sale?: Maybe<Scalars['String']['output']>;
  saleOutcome?: Maybe<Scalars['String']['output']>;
};

export enum Breed {
  All = 'ALL',
  Merino = 'MERINO',
  MidMicron = 'MID_MICRON',
  QuarterBred = 'QUARTER_BRED',
  Unclassified = 'UNCLASSIFIED',
  Xbd = 'XBD'
}

export type ContractDetail = {
  __typename?: 'ContractDetail';
  /** The name of the associated LoomPurchaseAccount (Talman: pa_name) */
  contractName?: Maybe<Scalars['String']['output']>;
  /** The number of bales contracted to supply (Talman: pa_qty) */
  contracted?: Maybe<Scalars['Decimal']['output']>;
  /** Greasy Length Range */
  greasyLengthRangeMax?: Maybe<Scalars['Decimal']['output']>;
  /** Greasy Length Range */
  greasyLengthRangeMin?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Minimum NKT acceptable to be able to fill this contract; test result must be equal to or higher than this number
   * (Talman: pa_ss)
   */
  nktMin?: Maybe<Scalars['Decimal']['output']>;
  /** Outstanding (i.e. how many bales need to be supplied to fulfill the contract) */
  outstanding: Scalars['Int']['output'];
  /** The Record Number of the associated LoomPurchaseAccount (Talman: pa_code) */
  purchaseAccountRecordNumber: Scalars['String']['output'];
  /**
   * Uses pa_mic along with pa_micu and pa_micd to work out min and max
   * The acceptable range for the micron test result to be able to fill this contract; test result must fall within this range
   * (Talman: pa_mic)
   */
  targetMicronMax?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Uses pa_mic along with pa_micu and pa_micd to work out min and max
   * The acceptable range for the micron test result to be able to fill this contract; test result must fall within this range
   * (Talman: pa_mic)
   */
  targetMicronMin?: Maybe<Scalars['Decimal']['output']>;
  /**
   * Maximum vegetable matter result acceptable to be able to fill this contract; test result must be equal to or lower than this number
   * (Talman: pa_vmb)
   */
  vmMax?: Maybe<Scalars['Decimal']['output']>;
};

export type ContractedLot = {
  __typename?: 'ContractedLot';
  /** nzwplot.lh_tbales */
  bales?: Maybe<Scalars['Decimal']['output']>;
  /** nzwplot.lh_text3 */
  lineNumber?: Maybe<Scalars['String']['output']>;
  /** nzwpcor.ct_mic */
  micron?: Maybe<Scalars['Decimal']['output']>;
  /** nzwplot.lh_rnetkg */
  netKg?: Maybe<Scalars['Decimal']['output']>;
  /** nzwplot.lh_tbales */
  paymentDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Calculated */
  priceClean?: Maybe<Scalars['Decimal']['output']>;
  /** nzwplot.lh_clp_code */
  redaType?: Maybe<Scalars['String']['output']>;
  /** nzwplot.lh_refno */
  reference: Scalars['String']['output'];
  /** Calculated */
  result?: Maybe<ContractedLotResult>;
};

export enum ContractedLotResult {
  Accepted = 'ACCEPTED',
  ToBeApproved = 'TO_BE_APPROVED',
  YetToDeliver = 'YET_TO_DELIVER'
}

export type CreateOfferResponse = {
  __typename?: 'CreateOfferResponse';
  /** A count of the email recipients. */
  emailRecipients: Scalars['Int']['output'];
  /** An associated error message if unsuccessful */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** If the request was successful. */
  offerCreationSuccess: Scalars['Boolean']['output'];
  /** The ID of the created Offer. */
  offerId?: Maybe<Scalars['UUID']['output']>;
  offerValidationFailureReason?: Maybe<OfferValidationFailureReason>;
  /** A count of the SMS messages sent. */
  smsCount: Scalars['Int']['output'];
  /** If the mutation was a success (or not) */
  success: Scalars['Boolean']['output'];
  woolLotValidationFailures: Array<WoolLotValidationFailure>;
};

/**
 * A combination of values taken straight from LoomCreditorHistory and LoomStation,
 * plus some transformed fields:
 *  - NetProceedsGSTInclusive is GST inclusive version of NetProceedsExGST,
 *  - AccountSalesDate is a date taken from BrokingAccountSalesDate or PrivateAccountSalesDate depending which one is not empty,
 *  - SaleAndSeason is combination of SaleIdentity and SaleSeason
 * See CreditorHistoryRules for implementation of field transformations.
 */
export type CreditorHistoryDetail = {
  __typename?: 'CreditorHistoryDetail';
  /** Calculated by the handler */
  accountSalesDate?: Maybe<Scalars['LocalDate']['output']>;
  /** nzwpcrh.cr_tgrpr */
  grossProceedsExGST?: Maybe<Scalars['Decimal']['output']>;
  /** Calculated by the handler */
  netProceedsGSTInclusive?: Maybe<Scalars['Decimal']['output']>;
  /** nzwpcrh.cr_prpdate */
  paymentDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Calculated by the handler */
  saleAndSeason?: Maybe<Scalars['String']['output']>;
  /** nzwpporg.po_brand */
  stationBrand?: Maybe<Scalars['String']['output']>;
  /** nzwpporg.po_code */
  stationRecordNumber: Scalars['String']['output'];
  /** nzwpcrh.cr_tbales */
  totalBalesInPayment?: Maybe<Scalars['Decimal']['output']>;
  /** nzwpcrh.cr_tnetkg */
  totalNetKgInPayment?: Maybe<Scalars['Decimal']['output']>;
};

export type CrmCompany = {
  __typename?: 'CrmCompany';
  accountManagerId?: Maybe<Scalars['String']['output']>;
  accountManagerNameFirstName?: Maybe<Scalars['String']['output']>;
  accountManagerNameLastName?: Maybe<Scalars['String']['output']>;
  createDate: Scalars['DateTime']['output'];
  crmLink?: Maybe<Scalars['String']['output']>;
  hsLastModifiedDate: Scalars['DateTime']['output'];
  hsObjectId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nzmAreaManagerFirstName?: Maybe<Scalars['String']['output']>;
  nzmAreaManagerId?: Maybe<Scalars['String']['output']>;
  nzmAreaManagerLastName?: Maybe<Scalars['String']['output']>;
  offerNotes?: Maybe<Scalars['String']['output']>;
  physicalAddressCityRegionState?: Maybe<Scalars['String']['output']>;
  physicalAddressCountry?: Maybe<Scalars['String']['output']>;
  physicalAddressNumber?: Maybe<Scalars['String']['output']>;
  physicalAddressRapidNumber?: Maybe<Scalars['String']['output']>;
  physicalAddressStreet?: Maybe<Scalars['String']['output']>;
  physicalAddressStreetAndSuburb: Scalars['String']['output'];
  physicalAddressSuburb?: Maybe<Scalars['String']['output']>;
  physicalAddressTown?: Maybe<Scalars['String']['output']>;
  stationRecordNumber: Scalars['String']['output'];
  tradingName?: Maybe<Scalars['String']['output']>;
};

/** Deletes a Speci */
export type DeleteSpeciRequestInput = {
  /** The Id of the Speci to delete */
  speciId: Scalars['UUID']['input'];
};

/** Request the contracts (purchase accounts) for a wool lot */
export type GetContractsDataRequestInput = {
  /** The target time */
  requestTime?: InputMaybe<Scalars['LocalDate']['input']>;
  /** The wool lot reference */
  woolLotReferenceNumber: Scalars['String']['input'];
};

/** A request to get a single offer */
export type GetOfferRequestInput = {
  offerId: Scalars['UUID']['input'];
};

export type GetOfferResponse = {
  __typename?: 'GetOfferResponse';
  offer: OfferDto;
};

export type GetPreviousLotsDataRequestInput = {
  woolLotReferenceNumber: Scalars['String']['input'];
};

export type GetPreviousLotsDataResponse = {
  __typename?: 'GetPreviousLotsDataResponse';
  results: Array<GetTypingProgramDataResponse>;
};

/** A response containing a single speci object */
export type GetSpeciResponse = {
  __typename?: 'GetSpeciResponse';
  /** Speci data transfer object */
  speci: SpeciDto;
};

/** Station details for Speci */
export type GetStationDetailsForSpeciResponse = {
  __typename?: 'GetStationDetailsForSpeciResponse';
  /** The brand of the station (Wool Brand on bales) */
  brand?: Maybe<Scalars['String']['output']>;
  /** The current season contracts for the station */
  currentSeasonContracts: Array<SpeciContractDetail>;
  /** If the station is RWS */
  isRws: Scalars['Boolean']['output'];
  /** RWS status of the station */
  rwsStatus?: Maybe<Scalars['String']['output']>;
  /** The trading name of the station */
  tradingName?: Maybe<Scalars['String']['output']>;
  /** ZQ status of the station */
  zqStatus?: Maybe<Scalars['String']['output']>;
  /** ZQRX status of the station */
  zqrxStatus?: Maybe<Scalars['String']['output']>;
};

/** Station details */
export type GetStationDetailsResponse = {
  __typename?: 'GetStationDetailsResponse';
  /** The brand of the station (Wool Brand on bales) */
  brand?: Maybe<Scalars['String']['output']>;
  /** If the station is RWS */
  isRws: Scalars['Boolean']['output'];
  /** RWS status of the station */
  rwsStatus?: Maybe<Scalars['String']['output']>;
  /** The description of the associated Station Group (if any). Also known as Farm Group Name */
  stationGroupDescription?: Maybe<Scalars['String']['output']>;
  /** The trading name of the station */
  tradingName?: Maybe<Scalars['String']['output']>;
  /** ZQ status of the station */
  zqStatus?: Maybe<Scalars['String']['output']>;
  /** ZQRX status of the station */
  zqrxStatus?: Maybe<Scalars['String']['output']>;
};

export type GetStationHeaderResponse = {
  __typename?: 'GetStationHeaderResponse';
  brand?: Maybe<Scalars['String']['output']>;
  isOnHold: Scalars['Boolean']['output'];
  recordNumber: Scalars['String']['output'];
  stationsInGroup?: Maybe<Array<StationStubDto>>;
};

export type GetTypingProgramDataRequestInput = {
  woolLotReferenceNumber: Scalars['String']['input'];
};

/** A combination of LoomWoolLot, LoomPurchaseAccount, LoomCoreTest and LoomBaleHeader to be used in the Typing Program. */
export type GetTypingProgramDataResponse = {
  __typename?: 'GetTypingProgramDataResponse';
  baleHeaderPurchaseBrand?: Maybe<Scalars['String']['output']>;
  baleHeaderPurchaseDescription?: Maybe<Scalars['String']['output']>;
  coreTestBoxLocation?: Maybe<Scalars['String']['output']>;
  coreTestBurrPercentage?: Maybe<Scalars['Decimal']['output']>;
  coreTestCoefficientOfVariationLaserscan?: Maybe<Scalars['Decimal']['output']>;
  coreTestColourYZ?: Maybe<Scalars['Decimal']['output']>;
  coreTestCurvatureMeanLaser?: Maybe<Scalars['Decimal']['output']>;
  coreTestHauteurLength?: Maybe<Scalars['Decimal']['output']>;
  coreTestId?: Maybe<Scalars['UUID']['output']>;
  coreTestMicron?: Maybe<Scalars['Decimal']['output']>;
  coreTestMicronAirflow?: Maybe<Scalars['Decimal']['output']>;
  coreTestMicronLaserscan?: Maybe<Scalars['Decimal']['output']>;
  coreTestMicronOfda?: Maybe<Scalars['Decimal']['output']>;
  coreTestPointOfBreakBase?: Maybe<Scalars['Decimal']['output']>;
  coreTestPointOfBreakMid?: Maybe<Scalars['Decimal']['output']>;
  coreTestPointOfBreakTip?: Maybe<Scalars['Decimal']['output']>;
  coreTestSeedShivePercentage?: Maybe<Scalars['Decimal']['output']>;
  coreTestStapleAverageStrength?: Maybe<Scalars['Decimal']['output']>;
  coreTestStapleCoefficientOfLengthVariation?: Maybe<Scalars['Decimal']['output']>;
  coreTestStapleLengthGreasy?: Maybe<Scalars['Decimal']['output']>;
  coreTestStapleStrength?: Maybe<Scalars['Decimal']['output']>;
  coreTestVegetableMatterBase?: Maybe<Scalars['Decimal']['output']>;
  coreTestYield1?: Maybe<Scalars['Decimal']['output']>;
  purchaseAccountName?: Maybe<Scalars['String']['output']>;
  purchaseAccountRecordType?: Maybe<Scalars['String']['output']>;
  purchaseAccountWarning?: Maybe<Scalars['String']['output']>;
  purchaseAccountingRecordType?: Maybe<Scalars['String']['output']>;
  qualityScheme?: Maybe<Scalars['String']['output']>;
  qualitySchemeWarning?: Maybe<Scalars['Boolean']['output']>;
  stationRecordNumber?: Maybe<Scalars['String']['output']>;
  woolLotActions?: Maybe<Scalars['String']['output']>;
  woolLotBales?: Maybe<Scalars['Decimal']['output']>;
  woolLotCode?: Maybe<Scalars['String']['output']>;
  woolLotCommissionPaymentDate?: Maybe<Scalars['LocalDate']['output']>;
  woolLotId: Scalars['UUID']['output'];
  woolLotInternalComment?: Maybe<Scalars['String']['output']>;
  woolLotLineNumber?: Maybe<Scalars['String']['output']>;
  woolLotReferenceNumber: Scalars['String']['output'];
  woolLotSaleNumber?: Maybe<Scalars['String']['output']>;
  woolLotSeason?: Maybe<Scalars['String']['output']>;
  woolLotSoldStatus: WoolSoldStatus;
  woolLotTypeCurrent?: Maybe<Scalars['String']['output']>;
  woolLotsTotalKilosClean?: Maybe<Scalars['Decimal']['output']>;
  woolLotsTotalKilosNet?: Maybe<Scalars['Decimal']['output']>;
};

export type GetWoolStoreToolRequestInput = {
  internalReferenceCode: Scalars['String']['input'];
};

/** A combination of LoomWoolLot and LoomBaleHeader to be used in the Wool Store Tool. */
export type GetWoolStoreToolResponse = {
  __typename?: 'GetWoolStoreToolResponse';
  baleHeaderPurchaseBrand?: Maybe<Scalars['String']['output']>;
  baleHeaderPurchaseDescription?: Maybe<Scalars['String']['output']>;
  baleHeaderSaleBrand?: Maybe<Scalars['String']['output']>;
  baleHeaderSampleLocation?: Maybe<Scalars['String']['output']>;
  coreTestBoxLocation?: Maybe<Scalars['String']['output']>;
  coreTestId?: Maybe<Scalars['UUID']['output']>;
  woolLotBales: Scalars['Decimal']['output'];
  woolLotCode?: Maybe<Scalars['String']['output']>;
  woolLotId: Scalars['UUID']['output'];
  woolLotPreviousSaleNumber?: Maybe<Scalars['String']['output']>;
  woolLotPreviousSeason?: Maybe<Scalars['String']['output']>;
  woolLotPreviousWoolLot?: Maybe<Scalars['String']['output']>;
  woolLotRecordNumber: Scalars['String']['output'];
  woolLotRecordSeason: Scalars['String']['output'];
  woolLotSaleNumber: Scalars['String']['output'];
  woolLotTypeCurrent?: Maybe<Scalars['String']['output']>;
  woolStorageCentreCode?: Maybe<Scalars['String']['output']>;
  woolStoreStatus: WoolSoldStatus;
};

export enum ListBaleDetailsOrderByOptions {
  BaleNumber = 'BALE_NUMBER',
  LineNumber = 'LINE_NUMBER'
}

/** A request to list all wool lots */
export type ListBaleDetailsRequestInput = {
  baleNumber?: InputMaybe<Scalars['String']['input']>;
  currentPage: Scalars['Int']['input'];
  orderBy: ListBaleDetailsOrderByOptions;
  orderByAscending: Scalars['Boolean']['input'];
  pageSize: Scalars['Int']['input'];
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  season?: InputMaybe<Scalars['String']['input']>;
  stationRecordNumber: Scalars['String']['input'];
};

export type ListBaleDetailsResponse = {
  __typename?: 'ListBaleDetailsResponse';
  currentPage: Scalars['Int']['output'];
  results: Array<BaleDetail>;
  totalNetKGs?: Maybe<Scalars['Decimal']['output']>;
  totalPageCount: Scalars['Int']['output'];
  totalResultCount: Scalars['Int']['output'];
};

/** Request the ContractDetail for station and time (season) */
export type ListContractDetailsForSeasonRequestInput = {
  /** The time of the request. Defaults to system time. */
  requestTime?: InputMaybe<Scalars['LocalDate']['input']>;
  /** The RecordNumber of the associated LoomStation (Talman: st_code) */
  stationRecordNumber: Scalars['String']['input'];
};

/** Request to get creditor history for stations */
export type ListCreditorHistoryRequestInput = {
  /** (Optional) The PaymentDate to start from */
  fromPaymentDate?: InputMaybe<Scalars['LocalDate']['input']>;
  /** (Optional) True if creditor history for all stations in station group should be returned */
  includeStationGroup?: Scalars['Boolean']['input'];
  /** The station record number. */
  stationRecordNumber: Scalars['String']['input'];
  /** (Optional) The PaymentDate to end at */
  toPaymentDate?: InputMaybe<Scalars['LocalDate']['input']>;
};

/** List of creditor history details */
export type ListCreditorHistoryResponse = {
  __typename?: 'ListCreditorHistoryResponse';
  /** List of Creditor History details */
  results: Array<CreditorHistoryDetail>;
  /** Sum of GrossProceedsExGST */
  sumOfGrossProceedsExGST: Scalars['Decimal']['output'];
  /** Sum of NetProceedsGSTInclusive */
  sumOfNetProceedsGSTInclusive: Scalars['Decimal']['output'];
  /** Sum of TotalBalesInPayment */
  sumOfTotalBales: Scalars['Decimal']['output'];
  /** Sum of TotalNetKgInPayment */
  sumOfTotalNetKg: Scalars['Decimal']['output'];
};

/** Request to get lot details for a station */
export type ListLotDetailsRequestInput = {
  /** (Optional) The breed, used for filtering */
  breed?: InputMaybe<Breed>;
  /** (Optional) The PurchaseAccountName, used for filtering */
  purchaseAccountName?: InputMaybe<Scalars['String']['input']>;
  /** (Optional) The Result (soldStatus), used for filtering */
  result?: InputMaybe<WoolSoldStatus>;
  /** (Optional) The SaleAndSeason, used for filtering */
  saleAndSeason?: InputMaybe<Scalars['String']['input']>;
  /** (Optional) The season, used for filtering */
  season?: InputMaybe<Scalars['String']['input']>;
  /** The station record number. */
  stationRecordNumber: Scalars['String']['input'];
  /** (Optional) The stock, used for filtering */
  stock?: InputMaybe<StockAge>;
};

/** Response object */
export type ListLotDetailsResponse = {
  __typename?: 'ListLotDetailsResponse';
  /** Totals from lot details */
  lotDetailTotals: LotDetailTotals;
  /** Weighted averages from lot details */
  lotDetailWeightedAverages: LotDetailWeightedAverages;
  /** List of lot details entities */
  results: Array<LotDetail>;
};

export enum ListOffersOrderByOptions {
  Created = 'CREATED'
}

/** A request to list all Offers */
export type ListOffersRequestInput = {
  currentPage: Scalars['Int']['input'];
  offerStatuses?: InputMaybe<Array<OfferStatus>>;
  orderBy: ListOffersOrderByOptions;
  orderByAscending: Scalars['Boolean']['input'];
  pageSize: Scalars['Int']['input'];
  season?: InputMaybe<Scalars['Int']['input']>;
  stationRecordNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ListOffersResponse = {
  __typename?: 'ListOffersResponse';
  currentPage: Scalars['Int']['output'];
  results: Array<OfferDto>;
  totalPageCount: Scalars['Int']['output'];
  totalResultCount: Scalars['Int']['output'];
};

/** Request the receival history data for a station */
export type ListReceivalHistoryRequestInput = {
  /** (Optional) The DateReceived to start from */
  fromDateReceived?: InputMaybe<Scalars['LocalDate']['input']>;
  /** The station record number */
  stationRecordNumber: Scalars['String']['input'];
  /** (Optional) The DateReceived to end at */
  toDateReceived?: InputMaybe<Scalars['LocalDate']['input']>;
};

/** Receival history details */
export type ListReceivalHistoryResponse = {
  __typename?: 'ListReceivalHistoryResponse';
  /** A list of receival histories */
  results: Array<ReceivalHistoryDetail>;
  /** A sum of all of TotalBalesReceived values */
  sumOfTotalBalesReceived: Scalars['Decimal']['output'];
};

/** Request to get sold wool summary for station */
export type ListSoldWoolSummaryRequestInput = {
  /** The first season to return, returns this season plus the five previous seasons. */
  firstSeason: Scalars['Int']['input'];
  /** The station record number. */
  stationRecordNumber: Scalars['String']['input'];
};

/** List of sold wool summaries */
export type ListSoldWoolSummaryResponse = {
  __typename?: 'ListSoldWoolSummaryResponse';
  /** List of sold wool summaries */
  results: Array<SoldWoolSummary>;
};

/** Request to get specis summaries for station */
export type ListSpeciRequestInput = {
  /** The status of Speci */
  speciStatus?: InputMaybe<SpeciStatus>;
  /** The type of Speci (Grower vs Hub) */
  speciType?: InputMaybe<SpeciType>;
  /** The station record number */
  stationRecordNumber: Scalars['String']['input'];
};

/** List of speci summary records */
export type ListSpeciResponse = {
  __typename?: 'ListSpeciResponse';
  /** List of speci summary records */
  results: Array<SpeciSummary>;
};

export enum ListTypedWoolLotsOrderByOptions {
  Actions = 'ACTIONS',
  Bales = 'BALES',
  DateChanged = 'DATE_CHANGED',
  InternalComment = 'INTERNAL_COMMENT',
  InternalReferenceCode = 'INTERNAL_REFERENCE_CODE',
  LastTyped = 'LAST_TYPED',
  SaleNumber = 'SALE_NUMBER',
  Season = 'SEASON',
  TypeCurrent = 'TYPE_CURRENT'
}

/** A request to list all wool lots */
export type ListTypedWoolLotsRequestInput = {
  currentPage: Scalars['Int']['input'];
  from?: InputMaybe<Scalars['DateTime']['input']>;
  orderBy: ListTypedWoolLotsOrderByOptions;
  orderByAscending: Scalars['Boolean']['input'];
  pageSize: Scalars['Int']['input'];
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListTypedWoolLotsResponse = {
  __typename?: 'ListTypedWoolLotsResponse';
  currentPage: Scalars['Int']['output'];
  results: Array<TypedWoolLot>;
  totalPageCount: Scalars['Int']['output'];
  totalResultCount: Scalars['Int']['output'];
};

/** Request to get unsold lot details */
export type ListUnsoldLotsRequestInput = {
  /** Filter tested lots */
  testedLots?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter typed lots */
  typedLots?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Response object */
export type ListUnsoldLotsResponse = {
  __typename?: 'ListUnsoldLotsResponse';
  /** List of unsold lot entities */
  results: Array<UnsoldLot>;
};

/** Request to get wool contracts for stations */
export type ListWoolContractsRequestInput = {
  /** (Optional) The season, used for filtering (targeting WoolExpectedDate/ContractDeliveryDate/pa_erdate). Eg: 2024 */
  season?: InputMaybe<Scalars['Int']['input']>;
  /** The station record number. */
  stationRecordNumber: Scalars['String']['input'];
};

/** List of wool contracts */
export type ListWoolContractsResponse = {
  __typename?: 'ListWoolContractsResponse';
  /** List of wool contracts */
  results: Array<WoolContract>;
  /** Sum of BalesContracted */
  sumOfBalesContracted: Scalars['Decimal']['output'];
};

export type LoomMutation = {
  __typename?: 'LoomMutation';
  addWelcomeMessage: MutationResponse;
  cancelOffer: MutationResponse;
  createOffer: CreateOfferResponse;
  deleteSpeci: MutationResponse;
  sendToWoolStore: MutationResponse;
  setBoxLocation: MutationResponse;
  setSpeci: MutationResponse;
  setTypingActions: MutationResponse;
  setTypingInternalComment: MutationResponse;
  setTypingTypeCurrent: MutationResponse;
  submitOffer: MutationResponse;
  submitSpeci: MutationResponse;
};


export type LoomMutationAddWelcomeMessageArgs = {
  message: Scalars['String']['input'];
};


export type LoomMutationCancelOfferArgs = {
  offerId: Scalars['UUID']['input'];
};


export type LoomMutationCreateOfferArgs = {
  expiryDateTime: Scalars['DateTime']['input'];
  from: Scalars['String']['input'];
  offerContactSelections: Array<OfferContactSelectionInput>;
  paymentDate: Scalars['LocalDate']['input'];
  personalisedComment?: InputMaybe<Scalars['String']['input']>;
  woolLotOfferModels: Array<WoolLotOfferModelInput>;
};


export type LoomMutationDeleteSpeciArgs = {
  request: DeleteSpeciRequestInput;
};


export type LoomMutationSendToWoolStoreArgs = {
  request: SendToWoolStoreRequestInput;
};


export type LoomMutationSetBoxLocationArgs = {
  request: SetBoxLocationRequestInput;
};


export type LoomMutationSetSpeciArgs = {
  speci: SpeciDtoInput;
  stationRecordNumber: Scalars['String']['input'];
};


export type LoomMutationSetTypingActionsArgs = {
  request: SetTypingActionsRequestInput;
};


export type LoomMutationSetTypingInternalCommentArgs = {
  request: SetTypingInternalCommentRequestInput;
};


export type LoomMutationSetTypingTypeCurrentArgs = {
  request: SetTypingTypeCurrentRequestInput;
};


export type LoomMutationSubmitOfferArgs = {
  request: SubmitOfferRequestInput;
};


export type LoomMutationSubmitSpeciArgs = {
  speciId: Scalars['UUID']['input'];
};

export type LoomQuery = {
  __typename?: 'LoomQuery';
  contractsData: Array<ContractDetail>;
  crmCompany?: Maybe<CrmCompany>;
  getOfferStations: Array<OfferStationOption>;
  listBaleDetails: ListBaleDetailsResponse;
  listContractDetailsForSeason: Array<ContractDetail>;
  listCreditorHistory?: Maybe<ListCreditorHistoryResponse>;
  listLotDetails?: Maybe<ListLotDetailsResponse>;
  listOffers: ListOffersResponse;
  listPreviousWoolLots?: Maybe<GetPreviousLotsDataResponse>;
  listReceivalHistory: ListReceivalHistoryResponse;
  listSoldWoolSummary?: Maybe<ListSoldWoolSummaryResponse>;
  listSpecis?: Maybe<ListSpeciResponse>;
  listTypedWoolLots: ListTypedWoolLotsResponse;
  listUnprocessedLots: Array<UnprocessedLotModel>;
  listUnsoldLots?: Maybe<ListUnsoldLotsResponse>;
  listWoolContracts?: Maybe<ListWoolContractsResponse>;
  notesAndContacts?: Maybe<NotesAndContactsResponse>;
  offer?: Maybe<GetOfferResponse>;
  speci?: Maybe<GetSpeciResponse>;
  stationDetails?: Maybe<GetStationDetailsResponse>;
  stationDetailsForSpeci?: Maybe<GetStationDetailsForSpeciResponse>;
  stationHeader?: Maybe<GetStationHeaderResponse>;
  stationSearch: Array<SearchStationResult>;
  typingProgramData?: Maybe<GetTypingProgramDataResponse>;
  welcomeMessage?: Maybe<Scalars['String']['output']>;
  woolStoreDirectory: Array<WoolStoreDirectoryEntry>;
  woolStoreTool?: Maybe<GetWoolStoreToolResponse>;
};


export type LoomQueryContractsDataArgs = {
  request: GetContractsDataRequestInput;
};


export type LoomQueryCrmCompanyArgs = {
  populateManagers?: Scalars['Boolean']['input'];
  stationRecordNumber: Scalars['String']['input'];
};


export type LoomQueryListBaleDetailsArgs = {
  request: ListBaleDetailsRequestInput;
};


export type LoomQueryListContractDetailsForSeasonArgs = {
  request: ListContractDetailsForSeasonRequestInput;
};


export type LoomQueryListCreditorHistoryArgs = {
  request: ListCreditorHistoryRequestInput;
};


export type LoomQueryListLotDetailsArgs = {
  request: ListLotDetailsRequestInput;
};


export type LoomQueryListOffersArgs = {
  request: ListOffersRequestInput;
};


export type LoomQueryListPreviousWoolLotsArgs = {
  request: GetPreviousLotsDataRequestInput;
};


export type LoomQueryListReceivalHistoryArgs = {
  request: ListReceivalHistoryRequestInput;
};


export type LoomQueryListSoldWoolSummaryArgs = {
  request: ListSoldWoolSummaryRequestInput;
};


export type LoomQueryListSpecisArgs = {
  request: ListSpeciRequestInput;
};


export type LoomQueryListTypedWoolLotsArgs = {
  request: ListTypedWoolLotsRequestInput;
};


export type LoomQueryListUnprocessedLotsArgs = {
  request: UnprocessedLotsRequestInput;
};


export type LoomQueryListUnsoldLotsArgs = {
  request: ListUnsoldLotsRequestInput;
};


export type LoomQueryListWoolContractsArgs = {
  request: ListWoolContractsRequestInput;
};


export type LoomQueryNotesAndContactsArgs = {
  stationInFarmGroup: Scalars['Boolean']['input'];
  stationRecordNumber: Scalars['String']['input'];
};


export type LoomQueryOfferArgs = {
  request: GetOfferRequestInput;
};


export type LoomQuerySpeciArgs = {
  speciId: Scalars['UUID']['input'];
};


export type LoomQueryStationDetailsArgs = {
  recordNumber: Scalars['String']['input'];
};


export type LoomQueryStationDetailsForSpeciArgs = {
  recordNumber: Scalars['String']['input'];
};


export type LoomQueryStationHeaderArgs = {
  recordNumber: Scalars['String']['input'];
};


export type LoomQueryStationSearchArgs = {
  limit?: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type LoomQueryTypingProgramDataArgs = {
  request: GetTypingProgramDataRequestInput;
};


export type LoomQueryWoolStoreToolArgs = {
  request: GetWoolStoreToolRequestInput;
};

/** A combination of OfferStatus and LoomWoolLotOfferStatus to represent the status of a LoomWoolLot"/> */
export enum LoomWoolLotOfferStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  UnderOffer = 'UNDER_OFFER'
}

export type LotDetail = {
  __typename?: 'LotDetail';
  /** Bales (total) (Talman: lh_tbales) */
  bales?: Maybe<Scalars['Decimal']['output']>;
  /** The clean weight (calculated from the net weight and the yield) */
  cleanKgs?: Maybe<Scalars['Decimal']['output']>;
  /** Lot no (broker) (Talman: lh_code) */
  code?: Maybe<Scalars['String']['output']>;
  /** Internal Comment (Talman: lh_intcomm) */
  comment?: Maybe<Scalars['String']['output']>;
  /** The co-efficient of the variation in micron (Talman: ct_lscvm) */
  coreTestCoefficientOfVariationLaserscan?: Maybe<Scalars['Decimal']['output']>;
  /** Colour (Y-Z core test) (Talman: ct_colyz) */
  coreTestColourYZ?: Maybe<Scalars['Decimal']['output']>;
  /** Micron (Talman: ct_mic) */
  coreTestMicron?: Maybe<Scalars['Decimal']['output']>;
  /** Micron (Airflow) (Talman: ct_afmic) */
  coreTestMicronAirflow?: Maybe<Scalars['Decimal']['output']>;
  /** Micron (Laserscan) (Talman: ct_lsmic) */
  coreTestMicronLaserscan?: Maybe<Scalars['Decimal']['output']>;
  /** Micron (OFDA) (Talman: ct_ofmic) */
  coreTestMicronOfda?: Maybe<Scalars['Decimal']['output']>;
  /** Point of break base (Talman: ct_pobb) */
  coreTestPointOfBreakBase?: Maybe<Scalars['Decimal']['output']>;
  /** Point of break mid (Talman: ct_pobm) */
  coreTestPointOfBreakMid?: Maybe<Scalars['Decimal']['output']>;
  /** Point of break tip (Talman: ct_pobt) */
  coreTestPointOfBreakTip?: Maybe<Scalars['Decimal']['output']>;
  /** Average Staple Strength (Talman: ct_avstr) */
  coreTestStapleAverageStrength?: Maybe<Scalars['Decimal']['output']>;
  /** Staple length (greasy core test) (Talman: ct_slen) */
  coreTestStapleLengthGreasy?: Maybe<Scalars['Decimal']['output']>;
  /** Staple strength (core test) (Talman: ct_str) */
  coreTestStapleStrength?: Maybe<Scalars['Decimal']['output']>;
  /** VMB (core test) (Talman: ct_vmb) */
  coreTestVegetableMatterBase?: Maybe<Scalars['Decimal']['output']>;
  /** Yield 1 (Talman: ct_yld1) */
  coreTestYield?: Maybe<Scalars['Decimal']['output']>;
  /** Wool Lot's Main Bale Header PurchaseDescription (Talman: bh_samploc) */
  description?: Maybe<Scalars['String']['output']>;
  /** The Wool Lot's Gross Proceeds (calculated) */
  grossProceeds?: Maybe<Scalars['Decimal']['output']>;
  /** Line Number (Talman: lh_text3) */
  lineNumber?: Maybe<Scalars['String']['output']>;
  /** Commission payment date (Talman: lh_comdate) */
  lottedDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Net Kilograms (Talman: lh_rnetkg) */
  netKgs?: Maybe<Scalars['Decimal']['output']>;
  /** Payment Date (Talman: lh_prpdate) */
  paymentDate?: Maybe<Scalars['LocalDate']['output']>;
  /** The Wool Lot's Clean Price for the current basis (calculated) */
  priceClean?: Maybe<Scalars['Decimal']['output']>;
  /** The Wool Lot's Greasy Price for the current basis (calculated) */
  priceGreasy?: Maybe<Scalars['Decimal']['output']>;
  /** The name of the Wool Lot's Purchase Account (Talman: pa_name) */
  purchaseAccountName?: Maybe<Scalars['String']['output']>;
  /** Quality scheme 2 (Talman: lh_qsch2) */
  qualityScheme2?: Maybe<Scalars['String']['output']>;
  /** Record type (Talman: lh_rtype) */
  recordType?: Maybe<Scalars['String']['output']>;
  /** Internal Comment (Talman: lh_intcomm) */
  referenceNumber?: Maybe<Scalars['String']['output']>;
  /** The Wool Lot's Sold Status Result */
  result?: Maybe<WoolSoldStatus>;
  /** Sale number (Talman: lh_sale) */
  sale?: Maybe<Scalars['String']['output']>;
  /** Sale Account Code (Talman: lh_scode) */
  saleAccount?: Maybe<Scalars['String']['output']>;
  /** A combination of SaleNumber (Talman: lh_sale) and Season (Talman: lh_season) */
  saleAndSeason?: Maybe<Scalars['String']['output']>;
  /** The location of the sample Wool (Talman: bh_samploc) */
  sample?: Maybe<Scalars['String']['output']>;
  /** Season (Talman: lh_season) */
  season?: Maybe<Scalars['String']['output']>;
  /** The current type (Talman: lh_typec) */
  type?: Maybe<Scalars['String']['output']>;
  /** Reweigh Input Time (Talman: ct_rwdate) */
  weighDate?: Maybe<Scalars['DateTime']['output']>;
};

/** Represents the totals of a list of LotDetail */
export type LotDetailTotals = {
  __typename?: 'LotDetailTotals';
  /** A total of Bale values */
  bales?: Maybe<Scalars['Decimal']['output']>;
  /** A total of GrossProceeds */
  grossProceeds?: Maybe<Scalars['Decimal']['output']>;
  /** A total of NetKgs */
  netKgs?: Maybe<Scalars['Decimal']['output']>;
};

/** Represents the weighted averages of a list of LotDetail */
export type LotDetailWeightedAverages = {
  __typename?: 'LotDetailWeightedAverages';
  coreTestCoefficientOfVariationLaserscan?: Maybe<Scalars['Decimal']['output']>;
  coreTestColourYZ?: Maybe<Scalars['Decimal']['output']>;
  coreTestMicron?: Maybe<Scalars['Decimal']['output']>;
  coreTestMicronAirflow?: Maybe<Scalars['Decimal']['output']>;
  coreTestMicronLaserscan?: Maybe<Scalars['Decimal']['output']>;
  coreTestMicronOfda?: Maybe<Scalars['Decimal']['output']>;
  coreTestPointOfBreakBase?: Maybe<Scalars['Decimal']['output']>;
  coreTestPointOfBreakMid?: Maybe<Scalars['Decimal']['output']>;
  coreTestPointOfBreakTip?: Maybe<Scalars['Decimal']['output']>;
  coreTestStapleAverageStrength?: Maybe<Scalars['Decimal']['output']>;
  coreTestStapleLengthGreasy?: Maybe<Scalars['Decimal']['output']>;
  coreTestStapleStrength?: Maybe<Scalars['Decimal']['output']>;
  coreTestVegetableMatterBase?: Maybe<Scalars['Decimal']['output']>;
  coreTestYield?: Maybe<Scalars['Decimal']['output']>;
  priceClean?: Maybe<Scalars['Decimal']['output']>;
  priceGreasy?: Maybe<Scalars['Decimal']['output']>;
};

/** A standardised response to a mutation */
export type MutationResponse = {
  __typename?: 'MutationResponse';
  /** An associated error message if unsuccessful */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** If the mutation was a success (or not) */
  success: Scalars['Boolean']['output'];
};

export type NotesAndContactsResponse = {
  __typename?: 'NotesAndContactsResponse';
  offerContactOptions: Array<OfferContactOption>;
  offerNotes?: Maybe<Scalars['String']['output']>;
};

export type OfferContactOption = {
  __typename?: 'OfferContactOption';
  crmLink?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  isStaffMember: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  mobilePhone?: Maybe<Scalars['String']['output']>;
  roles: Array<Scalars['String']['output']>;
  sendEmail: Scalars['Boolean']['output'];
  sendReminders: Scalars['Boolean']['output'];
  sendSms: Scalars['Boolean']['output'];
};

export type OfferContactSelectionInput = {
  crmLink?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  isStaffMember: Scalars['Boolean']['input'];
  lastName: Scalars['String']['input'];
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  roles: Array<Scalars['String']['input']>;
  sendEmail: Scalars['Boolean']['input'];
  sendReminders: Scalars['Boolean']['input'];
  sendSms: Scalars['Boolean']['input'];
};

/** A combination of LoomStation and Offer */
export type OfferDto = {
  __typename?: 'OfferDto';
  completedDateTime?: Maybe<Scalars['DateTime']['output']>;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  expiryDateTime: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  /** The WoolLotOffers for this Offer */
  lines: Array<WoolLotOfferDto>;
  offerFrom: Scalars['String']['output'];
  paymentDate: Scalars['LocalDate']['output'];
  personalisedComment?: Maybe<Scalars['String']['output']>;
  respondedBy?: Maybe<Scalars['String']['output']>;
  stationBrand?: Maybe<Scalars['String']['output']>;
  stationRecordNumber?: Maybe<Scalars['String']['output']>;
  status: OfferStatus;
  submittedOnBehalfOfGrower?: Maybe<Scalars['Boolean']['output']>;
};

export type OfferStationOption = {
  __typename?: 'OfferStationOption';
  brand?: Maybe<Scalars['String']['output']>;
  display: Scalars['String']['output'];
  recordNumber: Scalars['String']['output'];
};

export enum OfferStatus {
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Expired = 'EXPIRED',
  UnderOffer = 'UNDER_OFFER'
}

export enum OfferValidationFailureReason {
  /** The Wool Lot IDs supplied are not unique. */
  DuplicateWoolLotIds = 'DUPLICATE_WOOL_LOT_IDS',
  /** An offer must be made to only one station. */
  MoreThanOneStation = 'MORE_THAN_ONE_STATION',
  /** The Wool Lot IDs supplied are not found. */
  NoWoolLotOfferModels = 'NO_WOOL_LOT_OFFER_MODELS',
  /** At least one of the Wool Lots is already under offer or accepted. */
  WoolLotsAlreadyUnderOfferOrAccepted = 'WOOL_LOTS_ALREADY_UNDER_OFFER_OR_ACCEPTED'
}

export type ReceivalHistoryDetail = {
  __typename?: 'ReceivalHistoryDetail';
  /** nzwprxh.rx_rdate */
  dateReceived?: Maybe<Scalars['LocalDate']['output']>;
  /** nzwprxh.rx_pcode */
  purchaseAccountCode?: Maybe<Scalars['String']['output']>;
  /** nzwprxh.rx_stcent */
  storageCentreCode?: Maybe<Scalars['String']['output']>;
  /** nzwprxh.rx_tbales */
  totalBalesReceived?: Maybe<Scalars['Decimal']['output']>;
};

export type SearchStationResult = {
  __typename?: 'SearchStationResult';
  agentOrBuyer?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  isOnHold: Scalars['Boolean']['output'];
  recordNumber: Scalars['String']['output'];
  tradingName?: Maybe<Scalars['String']['output']>;
};

/** Request to complete (send to wool store) a Speci identified by speci guid parameter */
export type SendToWoolStoreRequestInput = {
  /** Whether currently logged in user should be included in BCC of the email. Defaults to false. */
  bccMyself?: Scalars['Boolean']['input'];
  /** Message to be included in the email content */
  emailMessage: Scalars['String']['input'];
  /** Subject of the email */
  emailSubject: Scalars['String']['input'];
  /** The guid of the speci */
  speciId: Scalars['UUID']['input'];
  /** Wool store email address */
  woolStoreEmailAddress: Scalars['String']['input'];
};

/** A request to set the box location of a Core Test */
export type SetBoxLocationRequestInput = {
  /** The value of the Box Location */
  boxLocation: Scalars['String']['input'];
  /** The ID of the CoreTest to update */
  coreTestId: Scalars['UUID']['input'];
};

/** A request to set the actions when typing a Wool Lot */
export type SetTypingActionsRequestInput = {
  /** The Actions to set on the Wool Lot */
  actions?: InputMaybe<Scalars['String']['input']>;
  /** The Wool Lot to update */
  woolLotId: Scalars['UUID']['input'];
};

/** A request to set the internal comment when typing a Wool Lot */
export type SetTypingInternalCommentRequestInput = {
  /** The InternalComment to set on the Wool Lot */
  internalComment?: InputMaybe<Scalars['String']['input']>;
  /** The Wool Lot to update */
  woolLotId: Scalars['UUID']['input'];
};

/** A request to set the actions when typing a Wool Lot */
export type SetTypingTypeCurrentRequestInput = {
  /** The TypeCurrent to set on the Wool Lot */
  typeCurrent?: InputMaybe<Scalars['String']['input']>;
  /** The Wool Lot to update */
  woolLotId: Scalars['UUID']['input'];
};

export type SoldWoolSummary = {
  __typename?: 'SoldWoolSummary';
  averageBaleWeight?: Maybe<Scalars['Int']['output']>;
  averageGrossPricePerKgExGST?: Maybe<Scalars['Decimal']['output']>;
  averageNetPricePerKgIncGST?: Maybe<Scalars['Decimal']['output']>;
  season?: Maybe<Scalars['String']['output']>;
  totalBales?: Maybe<Scalars['Int']['output']>;
  totalGrossProceedsExGST?: Maybe<Scalars['Decimal']['output']>;
  totalKgs?: Maybe<Scalars['Int']['output']>;
  totalNetProceedsIncGST?: Maybe<Scalars['Decimal']['output']>;
};

export enum SpeciConsignmentStatus {
  ConsignmentComplete = 'CONSIGNMENT_COMPLETE',
  ConsignmentNotCompleteHoldForBalance = 'CONSIGNMENT_NOT_COMPLETE_HOLD_FOR_BALANCE',
  ShearingNotCompleteSellQualifiedWool = 'SHEARING_NOT_COMPLETE_SELL_QUALIFIED_WOOL'
}

/** Contract detail for a speci */
export type SpeciContractDetail = {
  __typename?: 'SpeciContractDetail';
  /** The name of the associated LoomPurchaseAccount (Talman: pa_name) */
  contractName?: Maybe<Scalars['String']['output']>;
  /** The RecordNumber of the associated LoomPurchaseAccount (Talman: pa_code) */
  recordNumber: Scalars['String']['output'];
};

export type SpeciDto = {
  __typename?: 'SpeciDto';
  /** Breeds of sheep included in the Speci */
  breeds: Array<Scalars['String']['output']>;
  /** Classer working on the Speci (which may be different than currently logged in user) */
  classer?: Maybe<Scalars['String']['output']>;
  /** Comments from the classer */
  classerComment?: Maybe<Scalars['String']['output']>;
  /** The consignment status of the speci */
  consignmentStatus?: Maybe<SpeciConsignmentStatus>;
  /** The Id of the speci entity */
  id: Scalars['UUID']['output'];
  /** A list of the related SpeciLineDto. */
  lines: Array<SpeciLineDto>;
  /** The date and time the speci was sent to the wool store by NZM user */
  sentToWoolStoreAt?: Maybe<Scalars['DateTime']['output']>;
  /** The person (typically NZM user) that sent the speci to the wool store */
  sentToWoolStoreBy?: Maybe<Scalars['String']['output']>;
  /** The email address of the area manager of the station to which this speci is linked */
  stationAreaManagerEmail?: Maybe<Scalars['String']['output']>;
  /** The full name of the area manager of the station to which this speci is linked */
  stationAreaManagerFullName?: Maybe<Scalars['String']['output']>;
  /** The Type of Speci (Grower vs Hub) */
  type?: Maybe<SpeciType>;
  /** Wool store associated with the speci */
  woolStore?: Maybe<Scalars['String']['output']>;
};

export type SpeciDtoInput = {
  /** Breeds of sheep included in the Speci */
  breeds: Array<Scalars['String']['input']>;
  /** Classer working on the Speci (which may be different than currently logged in user) */
  classer?: InputMaybe<Scalars['String']['input']>;
  /** Comments from the classer */
  classerComment?: InputMaybe<Scalars['String']['input']>;
  /** The consignment status of the speci */
  consignmentStatus?: InputMaybe<SpeciConsignmentStatus>;
  /** The Id of the speci entity */
  id: Scalars['UUID']['input'];
  /** A list of the related SpeciLineDto. */
  lines: Array<SpeciLineDtoInput>;
  /** The date and time the speci was sent to the wool store by NZM user */
  sentToWoolStoreAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The person (typically NZM user) that sent the speci to the wool store */
  sentToWoolStoreBy?: InputMaybe<Scalars['String']['input']>;
  /** The email address of the area manager of the station to which this speci is linked */
  stationAreaManagerEmail?: InputMaybe<Scalars['String']['input']>;
  /** The full name of the area manager of the station to which this speci is linked */
  stationAreaManagerFullName?: InputMaybe<Scalars['String']['input']>;
  /** The Type of Speci (Grower vs Hub) */
  type?: InputMaybe<SpeciType>;
  /** Wool store associated with the speci */
  woolStore?: InputMaybe<Scalars['String']['input']>;
};

export type SpeciLineDto = {
  __typename?: 'SpeciLineDto';
  /** The Bale Numbers associated with the Line */
  baleNumbers: Array<Scalars['Int']['output']>;
  /** The Description of the Line */
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  /** The Instructions or Contract name that the Line is intended for */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The Line Number, an optional identifier for the Line */
  number?: Maybe<Scalars['String']['output']>;
  /** The original instructions from the SpeciLine created by the external user (for Hub Speci versions) */
  originalInstructions?: Maybe<Scalars['String']['output']>;
  /** The Traditional Description of the Line */
  traditionalDescription?: Maybe<Scalars['String']['output']>;
};

export type SpeciLineDtoInput = {
  /** The Bale Numbers associated with the Line */
  baleNumbers: Array<Scalars['Int']['input']>;
  /** The Description of the Line */
  description: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
  /** The Instructions or Contract name that the Line is intended for */
  instructions?: InputMaybe<Scalars['String']['input']>;
  /** The Line Number, an optional identifier for the Line */
  number?: InputMaybe<Scalars['String']['input']>;
  /** The original instructions from the SpeciLine created by the external user (for Hub Speci versions) */
  originalInstructions?: InputMaybe<Scalars['String']['input']>;
  /** The Traditional Description of the Line */
  traditionalDescription?: InputMaybe<Scalars['String']['input']>;
};

export enum SpeciStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS'
}

export type SpeciSummary = {
  __typename?: 'SpeciSummary';
  author: Scalars['String']['output'];
  breeds: Array<Scalars['String']['output']>;
  completed?: Maybe<Scalars['DateTime']['output']>;
  created: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  originalSpeciCompleted?: Maybe<Scalars['DateTime']['output']>;
  originalSpeciCreated?: Maybe<Scalars['DateTime']['output']>;
  originalSpeciId?: Maybe<Scalars['UUID']['output']>;
  originalSpeciSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  originalSpeciSubmittedBy?: Maybe<Scalars['String']['output']>;
  sentToWoolStoreAt?: Maybe<Scalars['DateTime']['output']>;
  sentToWoolStoreBy?: Maybe<Scalars['String']['output']>;
  status: SpeciStatus;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  submittedBy?: Maybe<Scalars['String']['output']>;
  totalBales: Scalars['Int']['output'];
};

export enum SpeciType {
  Grower = 'GROWER',
  Hub = 'HUB'
}

export type StationStubDto = {
  __typename?: 'StationStubDto';
  brand: Scalars['String']['output'];
  recordNumber: Scalars['String']['output'];
};

export enum StockAge {
  All = 'ALL',
  Ewes = 'EWES',
  Hoggets = 'HOGGETS',
  Lambs = 'LAMBS',
  Unclassified = 'UNCLASSIFIED',
  Wethers = 'WETHERS'
}

export type SubmitOfferRequestInput = {
  offerId: Scalars['UUID']['input'];
  woolLotOfferDecisions: Array<WoolLotOfferDecisionInput>;
};

/** A combination of LoomStation and LoomWoolLot */
export type TypedWoolLot = {
  __typename?: 'TypedWoolLot';
  actions?: Maybe<Scalars['String']['output']>;
  baleHeaderDetails: Array<TypedWoolLotBaleHeaderDetails>;
  bales: Scalars['Decimal']['output'];
  code?: Maybe<Scalars['String']['output']>;
  dateChanged: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  internalComment?: Maybe<Scalars['String']['output']>;
  internalReferenceCode?: Maybe<Scalars['String']['output']>;
  lastTyped: Scalars['DateTime']['output'];
  purchaseBrand?: Maybe<Scalars['String']['output']>;
  saleNumber: Scalars['String']['output'];
  season: Scalars['String']['output'];
  stationId: Scalars['UUID']['output'];
  stationRecordNumber: Scalars['String']['output'];
  typeCurrent?: Maybe<Scalars['String']['output']>;
};

export type TypedWoolLotBaleHeaderDetails = {
  __typename?: 'TypedWoolLotBaleHeaderDetails';
  isMainHeaderForWoolLot: Scalars['Boolean']['output'];
  purchaseBrand: Scalars['String']['output'];
};

export type UnprocessedLotModel = {
  __typename?: 'UnprocessedLotModel';
  /** Commission payment date (Talman: lh_comdate) */
  commissionPaymentDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Internal reference code (Talman: lh_refno) */
  internalReferenceCode: Scalars['String']['output'];
  /** Line Number (Talman: lh_text3) */
  lineNumber?: Maybe<Scalars['String']['output']>;
  /**
   * Original Net Kilograms (Talman: lh_onetkg)
   * Both the onetkg and rnetkg refer to a GREASY weight. They will be the same figure unless that line
   * has had a sample removed which means taking 2-10 kgs out of the line to get a new sample,
   * in which case the rnetkg reduces by that value
   */
  netKg?: Maybe<Scalars['Decimal']['output']>;
  /** Purchase Description (Talman: bh_descp) */
  purchaseDescription?: Maybe<Scalars['String']['output']>;
  /** Sale number (Talman: lh_sale) */
  saleNumber: Scalars['String']['output'];
  /** Bales (total) (Talman: lh_tbales) */
  totalBales: Scalars['Decimal']['output'];
};

export type UnprocessedLotsRequestInput = {
  stationRecordNumber: Scalars['String']['input'];
};

export type UnsoldLot = {
  __typename?: 'UnsoldLot';
  code?: Maybe<Scalars['String']['output']>;
  coreTestColourYZ?: Maybe<Scalars['Decimal']['output']>;
  coreTestMicron?: Maybe<Scalars['Decimal']['output']>;
  coreTestStapleLengthGreasy?: Maybe<Scalars['Decimal']['output']>;
  coreTestStapleStrength?: Maybe<Scalars['Decimal']['output']>;
  coreTestVegetableMatterBase?: Maybe<Scalars['Decimal']['output']>;
  coreTestYield?: Maybe<Scalars['Decimal']['output']>;
  interlotWarning: Scalars['Boolean']['output'];
  internalComment?: Maybe<Scalars['String']['output']>;
  internalReferenceCode: Scalars['String']['output'];
  lineNumber?: Maybe<Scalars['String']['output']>;
  mainBaleHeaderPurchaseDescription?: Maybe<Scalars['String']['output']>;
  netKg?: Maybe<Scalars['Decimal']['output']>;
  purchaseAccountName?: Maybe<Scalars['String']['output']>;
  qualityScheme2?: Maybe<Scalars['String']['output']>;
  qualitySchemeWarning: Scalars['Boolean']['output'];
  saleNumber?: Maybe<Scalars['String']['output']>;
  season?: Maybe<Scalars['String']['output']>;
  stationBrand?: Maybe<Scalars['String']['output']>;
  stationRecordNumber?: Maybe<Scalars['String']['output']>;
  /** The status of the offers made on the lot */
  status?: Maybe<LoomWoolLotOfferStatus>;
  totalBales?: Maybe<Scalars['Decimal']['output']>;
  typeCurrent?: Maybe<Scalars['String']['output']>;
};

/**
 * A representation of LoomPurchaseAccount for Wool Contracts functionality,
 * some fields are transformed:
 *  - MicronMin is minimum acceptable micron for the contract
 *  - MicronMax is maximum acceptable micron for the contract
 *  - TargetMinimumYield is minimum acceptable yield for the contract
 *  - GreasyLengthMin is minimum acceptable greasy length for the contract
 *  - GreasyLengthMax is maximum acceptable greasy length for the contract
 * See ListWoolContractsHandler for implementation of field transformations.
 */
export type WoolContract = {
  __typename?: 'WoolContract';
  /** nzwppacc.pa_pprice */
  averagePriceCLN?: Maybe<Scalars['Decimal']['output']>;
  /** nzwppacc.pa_qty */
  balesContracted?: Maybe<Scalars['Decimal']['output']>;
  /** nzwppacc.pa_colour */
  colourDescription?: Maybe<Scalars['String']['output']>;
  /** nzwppacc.pa_erdate */
  contractDeliveryDate?: Maybe<Scalars['LocalDate']['output']>;
  /** If the Grower has signed the contract */
  contractIsSigned: Scalars['Boolean']['output'];
  /** nzwppacc.pa_name */
  contractName?: Maybe<Scalars['String']['output']>;
  contractedLots: Array<ContractedLot>;
  /** Calculated by the handler */
  greasyLengthMax?: Maybe<Scalars['Decimal']['output']>;
  /** Calculated by the handler */
  greasyLengthMin?: Maybe<Scalars['Decimal']['output']>;
  /** Calculated by the handler */
  micronMax?: Maybe<Scalars['Decimal']['output']>;
  /** Calculated by the handler */
  micronMin?: Maybe<Scalars['Decimal']['output']>;
  /** nzwppacc.pa_code */
  purchaseAccountRecordNumber: Scalars['String']['output'];
  /** nzwppacc.pa_style */
  styleDescription?: Maybe<Scalars['String']['output']>;
  /** nzwppacc.pa_gsl */
  targetGreasyLength?: Maybe<Scalars['Decimal']['output']>;
  /** nzwppacc.pa_mic */
  targetMicron?: Maybe<Scalars['Decimal']['output']>;
  /** Calculated by the handler */
  targetMinimumYield?: Maybe<Scalars['Decimal']['output']>;
  /** nzwppacc.pa_ss */
  targetSampleStrength?: Maybe<Scalars['Decimal']['output']>;
  /** nzwppacc.pa_vmb */
  targetVegetableMatter?: Maybe<Scalars['Decimal']['output']>;
  /** Calculated sum of TotalBales of all ContractedLots with a Result of Accepted */
  totalBalesAccepted?: Maybe<Scalars['Decimal']['output']>;
};

export type WoolLotOfferDecisionInput = {
  accepted: Scalars['Boolean']['input'];
  woolLotOfferId: Scalars['UUID']['input'];
};

/** A client-side representation of WoolLotOffer */
export type WoolLotOfferDto = {
  __typename?: 'WoolLotOfferDto';
  /** The brand partner for which the price offer is destined, displayed on the offer alongside the price */
  brandPartner?: Maybe<Scalars['String']['output']>;
  /** The clean market price for the WoolLot - units of cents per kg */
  cleanMarketPrice?: Maybe<Scalars['Int']['output']>;
  /** The clean price offered for the WoolLot - units of cents per kg */
  cleanOfferPrice?: Maybe<Scalars['Int']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  coreTestColourYZ?: Maybe<Scalars['Decimal']['output']>;
  coreTestMicron?: Maybe<Scalars['Decimal']['output']>;
  coreTestStapleLengthGreasy?: Maybe<Scalars['Decimal']['output']>;
  coreTestStapleStrength?: Maybe<Scalars['Decimal']['output']>;
  coreTestVegetableMatterBase?: Maybe<Scalars['Decimal']['output']>;
  coreTestYield?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The setting controlling if value add should be displayed on the offer
   * Normally, NZM staff choose not to display value add on the offer if it is a very small benefit to the grower
   */
  displayValueAdd?: Maybe<Scalars['Boolean']['output']>;
  /** The greasy market price for the WoolLot - units of cents per kg */
  greasyMarketPrice?: Maybe<Scalars['Int']['output']>;
  /** The greasy price offered for the WoolLot - units of cents per kg */
  greasyOfferPrice?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  interlotWarning: Scalars['Boolean']['output'];
  internalComment?: Maybe<Scalars['String']['output']>;
  internalReferenceCode: Scalars['String']['output'];
  lineNumber?: Maybe<Scalars['String']['output']>;
  mainBaleHeaderPurchaseDescription?: Maybe<Scalars['String']['output']>;
  netKg?: Maybe<Scalars['Decimal']['output']>;
  purchaseAccountName?: Maybe<Scalars['String']['output']>;
  qualityScheme2?: Maybe<Scalars['String']['output']>;
  qualitySchemeWarning: Scalars['Boolean']['output'];
  saleNumber?: Maybe<Scalars['String']['output']>;
  season?: Maybe<Scalars['String']['output']>;
  stationBrand?: Maybe<Scalars['String']['output']>;
  stationRecordNumber?: Maybe<Scalars['String']['output']>;
  /** The status of the offers made on the lot */
  status?: Maybe<LoomWoolLotOfferStatus>;
  totalBales?: Maybe<Scalars['Decimal']['output']>;
  typeCurrent?: Maybe<Scalars['String']['output']>;
  /**
   * The value add of the price offer - units of dollars for entire lot
   * This represents benefit to the grower if they accept the offer
   * This is calculated client-side (in the Hub front-end)
   */
  valueAdd?: Maybe<Scalars['Decimal']['output']>;
};

/** The data for creating a WoolLotOffer. */
export type WoolLotOfferModelInput = {
  /** The brand partner for which the price offer is destined, displayed on the offer alongside the price */
  brandPartner?: InputMaybe<Scalars['String']['input']>;
  /** The clean market price for the WoolLot - units of cents per kg */
  cleanMarketPrice?: InputMaybe<Scalars['Int']['input']>;
  /** The clean price offered for the WoolLot - units of cents per kg */
  cleanOfferPrice?: InputMaybe<Scalars['Int']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  coreTestColourYZ?: InputMaybe<Scalars['Decimal']['input']>;
  coreTestMicron?: InputMaybe<Scalars['Decimal']['input']>;
  coreTestStapleLengthGreasy?: InputMaybe<Scalars['Decimal']['input']>;
  coreTestStapleStrength?: InputMaybe<Scalars['Decimal']['input']>;
  coreTestVegetableMatterBase?: InputMaybe<Scalars['Decimal']['input']>;
  coreTestYield?: InputMaybe<Scalars['Decimal']['input']>;
  /**
   * The setting controlling if value add should be displayed on the offer
   * Normally, NZM staff choose not to display value add on the offer if it is a very small benefit to the grower
   */
  displayValueAdd?: InputMaybe<Scalars['Boolean']['input']>;
  /** The greasy market price for the WoolLot - units of cents per kg */
  greasyMarketPrice?: InputMaybe<Scalars['Int']['input']>;
  /** The greasy price offered for the WoolLot - units of cents per kg */
  greasyOfferPrice?: InputMaybe<Scalars['Int']['input']>;
  interlotWarning: Scalars['Boolean']['input'];
  internalComment?: InputMaybe<Scalars['String']['input']>;
  internalReferenceCode: Scalars['String']['input'];
  lineNumber?: InputMaybe<Scalars['String']['input']>;
  mainBaleHeaderPurchaseDescription?: InputMaybe<Scalars['String']['input']>;
  netKg?: InputMaybe<Scalars['Decimal']['input']>;
  purchaseAccountName?: InputMaybe<Scalars['String']['input']>;
  qualityScheme2?: InputMaybe<Scalars['String']['input']>;
  qualitySchemeWarning: Scalars['Boolean']['input'];
  saleNumber?: InputMaybe<Scalars['String']['input']>;
  season?: InputMaybe<Scalars['String']['input']>;
  stationBrand?: InputMaybe<Scalars['String']['input']>;
  stationRecordNumber?: InputMaybe<Scalars['String']['input']>;
  totalBales?: InputMaybe<Scalars['Decimal']['input']>;
  typeCurrent?: InputMaybe<Scalars['String']['input']>;
  /**
   * The value add of the price offer - units of dollars for entire lot
   * This represents benefit to the grower if they accept the offer
   * This is calculated client-side (in the Hub front-end)
   */
  valueAdd?: InputMaybe<Scalars['Decimal']['input']>;
};

export enum WoolLotOfferStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED'
}

export type WoolLotValidationFailure = {
  __typename?: 'WoolLotValidationFailure';
  /** The Id of the WoolLotOffer which already exists for this WoolLot. */
  existingWoolLotOfferId?: Maybe<Scalars['UUID']['output']>;
  /** The status of the WoolLot at the time of the Offer. */
  existingWoolLotOfferStatus?: Maybe<WoolLotOfferStatus>;
  /** The Id of the WoolLot which already has an offer. */
  woolLotId: Scalars['UUID']['output'];
};

export enum WoolSoldStatus {
  SoldOrBin = 'SOLD_OR_BIN',
  Unsold = 'UNSOLD'
}

/** A single wool store's email address and display label. */
export type WoolStoreDirectoryEntry = {
  __typename?: 'WoolStoreDirectoryEntry';
  /** The wool store's email address */
  email: Scalars['String']['output'];
  /** The display label shown to Hub users (e.g. "Christchurch Store") */
  label: Scalars['String']['output'];
};
